import React, { useMemo } from "react";
import { HostScreenQuestionItem } from "../hostScreenQuestionItem/HostScreenQuestionItem";
import { style as hostScreenWithSummaryQuestionItemStyle } from "./HostScreenWithSummaryQuestionItem.style";
import { HostScreenWithSummaryAnswers } from "./hostScreenWithSummaryAnswers/HostScreenWithSummaryAnswers";
const HostScreenWithSummaryQuestionItem = ({ domain, country, question, questionParentId, level, children, cta, tradename, segment, }) => {
    const style = useMemo(() => hostScreenWithSummaryQuestionItemStyle(), []);
    return (React.createElement(HostScreenQuestionItem, { country: country, cta: cta, domain: domain, level: level, question: question, questionParentId: questionParentId, segment: segment, testID: "host-screen-with-summary-question-item", tradename: tradename },
        children,
        React.createElement(HostScreenWithSummaryAnswers, { domain: domain, question: question, segment: segment, style: style.summary })));
};
export { HostScreenWithSummaryQuestionItem };
